import React from 'react';
import { CustomColumnProps, ExportGridRef } from '@ihsm/ui-shared';
import { ReactDataGrid } from '../../ReactDataGrid';

export const PortfoliosSceneGrid: React.FC<{
  data: any[];
  columns: CustomColumnProps[];
  gridExportRef: React.RefObject<ExportGridRef>;
  exportFileName: string;
}> = ({ data, columns, gridExportRef, exportFileName }) => (
  <ReactDataGrid
    showSortingControls
    gridExportRef={gridExportRef}
    exportFileName={exportFileName}
    selectByRowClick={false}
    data={data}
    columns={columns}
  />
);
